import { ModeNamesEnum } from '../../models/browse-mode';
import {
  BrowseFilter,
  FilterNamesEnum,
  getAllFiltersInSearchMode,
  getAvailableFilters,
  getFiltersCopy,
} from '../../models/filter';

export class FilterState {
  videoFilters: BrowseFilter[] = getAvailableFilters({
    modeName: ModeNamesEnum.Videos,
  });
  playlistFilters: BrowseFilter[] = getFiltersCopy();
  gpsFilters: BrowseFilter[] = getAvailableFilters({
    modeName: ModeNamesEnum.Gps,
  });
  workoutFilters: BrowseFilter[] = getAvailableFilters({
    modeName: ModeNamesEnum.Workouts,
  });
  coachingFilters: BrowseFilter[] = getAvailableFilters({
    modeName: ModeNamesEnum.Coachings,
  });
  searchedContentFilters: BrowseFilter[] = getAllFiltersInSearchMode(
    getFiltersCopy().find((f) => f.name === FilterNamesEnum.SearchMode)
  );
  mapFilters: BrowseFilter[] = getAvailableFilters({
    modeName: ModeNamesEnum.Videos,
  });
}
